export default __webpack_public_path__ + "static/media/ID_SCHOOL_DRAKE.64b70004.jpg";